import { CommonModule, DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import {
  MatAutocomplete,
  MatAutocompleteTrigger,
} from '@angular/material/autocomplete';
import { MatNativeDateModule, MatOption } from '@angular/material/core';
import {
  MatDatepicker,
  MatDatepickerInput,
  MatDatepickerModule,
  MatDatepickerToggle,
} from '@angular/material/datepicker';
import {
  MatError,
  MatFormField,
  MatLabel,
  MatSuffix,
} from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { MatSelect } from '@angular/material/select';
import { MatTooltip } from '@angular/material/tooltip';
import { Router } from '@angular/router';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject, takeUntil } from 'rxjs';
import { ApiServiceService } from '../api-service.service';
import { CommonInfoTooltipComponent } from '../common-component-info-tooltip/common-component-info-tooltip.component';
import { CommonPaginationComponent } from '../common-component-pagination/common-component-pagination.component';
import { CommonSearchComponent } from '../common-component-search/common-component-search.component';
import { IndianNumberPipe } from '../pipes/indian-number.pipe';
import { ticketStatusKpiInfo } from '../shared/info-text/ticket-status-kpi.info';
import { TicketingInfoComponent } from '../ticketing-info/ticketing-info.component';

@Component({
  selector: 'app-ais140-ticket-list',
  templateUrl: './ais140-ticket-list.component.html',
  styleUrls: ['./ais140-ticket-list.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatIcon,
    NgxPaginationModule,
    MatFormField,
    MatLabel,
    MatInput,
    MatDatepickerInput,
    MatDatepickerToggle,
    MatSuffix,
    MatTooltip,
    MatDatepicker,
    MatSelect,
    NgxMatSelectSearchModule,
    MatOption,
    MatError,
    DatePipe,
    MatDatepickerModule,
    MatNativeDateModule,
    CommonSearchComponent,
    CommonPaginationComponent,
    IndianNumberPipe,
    MatAutocomplete,
    MatAutocompleteTrigger,
    CommonInfoTooltipComponent,
    TicketingInfoComponent,
  ],
})
export class AIS140TicketListComponent implements OnInit, OnDestroy {
  size = 10;
  page = 1;
  totalLength = 0;
  assignedToId = '';
  listOfData: {
    _id: string;
    ticketNo: string;
    uid: string;
    imei: string;
    vinNo: string;
    rtoState: string;
    deviceType: string;
    InstitutionalSales: string;
    assignedUser: string;
    remarkbyaccolade: string;
    remark: string;
    assignDate: string;
    ticketEndDate: string;
  }[] = [];
  simplifiedTicketStatus: Record<string, string> = {
    STS_CO_01: 'Not Assigned',
    STS_CO_02: 'Assigned',
    STS_CO_03: 'Started',
    STS_CO_04: 'In Queue',
    STS_CO_05: 'In Progress',
    STS_CO_06: 'Completed',
    STS_CO_07: 'On Hold Due to Vehicle Not Available',
    STS_CO_08: 'On Hold Due to Ignition Not ON',
    STS_CO_09: 'On Hold Due to GSM Network Not Available',
    STS_CO_10: 'On Hold Due to Invalid GPS',
    STS_CO_11: 'On Hold Due To Vahan Portal Down',
    STS_CO_12: 'On Hold Due to Data not Available on VAHAN',
    STS_CO_13: 'On Hold Due to Backend Portal Down',
    STS_CO_14: 'On Hold Due to Panic Event Not Confirmed',
    STS_CO_15: 'On Hold Due to OTP not being received',
    STS_CO_16: 'On Hold Due to Live Location Pending from Backend',
    STS_CO_17: 'On Hold Due to Waiting for RTO Approval',
    STS_CO_18: 'Ticket Completed and Closed',
    STS_CO_19: 'Ticket Generated but Data Not Received from CRM',
    STS_CO_20: 'Ticket Cancelled Due to Change Request Device Change',
    STS_CO_21: 'Ticket Cancelled Due to Change Request Vehicle Owner Change',
    STS_CO_22: 'Ticket Cancelled Due to Change Request RTO or State Change',
    STS_CO_23: 'Ticket Cancelled as per Request',
    STS_CO_24: 'Ticket Cancelled Due to Invoice Cancelled',
    STS_CO_25: 'Change required from CRM',
    STS_CO_26: 'Other',
    STS_CO_28: 'On Hold Due to Non-Working Hours',
    STS_CO_29: 'On Hold Due to SIM Validity Issue',
    STS_CO_30: 'Ticket Suspended Due to Customer Not Responding',
    STS_CO_31: 'On Hold Due to No Response from Customer',
    STS_CO_32: 'On Hold Due to Customer Details Mismatch',
  };

  allCount = 0;
  completed = 0;
  cancelled = 0;
  inProgress = 0;
  onHold = 0;

  // Plain-language explanations shown by the info-tooltip icons on each KPI
  // card, kept in a shared file (imported above) since the Ticket Dashboard
  // shows the same KPI cards backed by the same endpoint, for isolation
  // from this component's logic.
  kpiInfo = ticketStatusKpiInfo;

  table_title = 'PRO';
  kpiCardSelected = 'PRO';

  ticketCompletedAtFromDate = '';
  ticketCompletedAtToDate = '';
  fromDate = '';
  toDate = '';
  listOfState = [];
  filteredListOfState = [];
  stateNameFilterCtrl: FormControl = new FormControl();
  listOfDealers = [];
  filteredListOfDealers = [];
  dealerCodeFilterCtrl: FormControl = new FormControl();
  listOfAssignedUser = [];
  filteredListOfAssignedUser = [];
  userNameFilterCtrl: FormControl = new FormControl();
  initiatedByList = [
    {
      initiatedByName: 'TML CRM & FE',
      initiatedByValue: 'crm',
    },
    {
      initiatedByName: 'Institutional Sales AEPL',
      initiatedByValue: 'inst',
    },
  ];
  deviceTypeList = [
    {
      deviceTypeName: 'TCU2G',
      deviceTypeValue: 'ATCU2G',
    },
    {
      deviceTypeName: 'TCU4G',
      deviceTypeValue: 'ATCU4G',
    },
  ];

  tatTypeList = [
    {
      tatTypeName: 'LESS_THAN_4',
      tatTypeValue: 'LESS_THAN_4',
    },
    {
      tatTypeName: 'LESS_THAN_10',
      tatTypeValue: 'LESS_THAN_10',
    },
    {
      tatTypeName: 'MORE_THAN_10',
      tatTypeValue: 'MORE_THAN_10',
    },
    {
      tatTypeName: 'IN_PROGRESS',
      tatTypeValue: 'IN_PROGRESS',
    },
    {
      tatTypeName: 'ON_HOLD',
      tatTypeValue: 'ON_HOLD',
    },
    {
      tatTypeName: 'ON_HOLD_DUE_TO_RTO_APPROVAL',
      tatTypeValue: 'ON_HOLD_DUE_TO_RTO_APPROVAL',
    },
    {
      tatTypeName: 'ON_HOLD_DUE_TO_SUSPENDED_OR_OTHER',
      tatTypeValue: 'ON_HOLD_DUE_TO_SUSPENDED_OR_OTHER',
    },
  ];

  listOfTicketStatus = [
    {
      statusCode: 'STS_CO_01',
      status: 'Not Assigned',
    },
    {
      statusCode: 'STS_CO_02',
      status: 'Assigned',
    },
    {
      statusCode: 'STS_CO_03',
      status: 'Started',
    },
    {
      statusCode: 'STS_CO_04',
      status: 'In Queue',
    },
    {
      statusCode: 'STS_CO_05',
      status: 'In Progress',
    },
    {
      statusCode: 'STS_CO_06',
      status: 'Completed',
    },
    {
      statusCode: 'STS_CO_07',
      status: 'On Hold Due to Vehicle Not Available',
    },
    {
      statusCode: 'STS_CO_08',
      status: 'On Hold Due to Ignition Not ON',
    },
    {
      statusCode: 'STS_CO_09',
      status: 'On Hold Due to GSM Network Not Available',
    },
    {
      statusCode: 'STS_CO_10',
      status: 'On Hold Due to Invalid GPS',
    },
    {
      statusCode: 'STS_CO_11',
      status: 'On Hold Due To Vahan Portal Down',
    },
    {
      statusCode: 'STS_CO_12',
      status: 'On Hold Due to Data not Available on VAHAN',
    },
    {
      statusCode: 'STS_CO_13',
      status: 'On Hold Due to Backend Portal Down',
    },
    {
      statusCode: 'STS_CO_14',
      status: 'On Hold Due to Panic Event Not Confirmed',
    },
    {
      statusCode: 'STS_CO_15',
      status: 'On Hold Due to OTP not being received',
    },
    {
      statusCode: 'STS_CO_16',
      status: 'On Hold Due to Live Location Pending from Backend',
    },
    {
      statusCode: 'STS_CO_17',
      status: 'On Hold Due to Waiting for RTO Approval',
    },
    {
      statusCode: 'STS_CO_18',
      status: 'Ticket Completed and Closed',
    },
    {
      statusCode: 'STS_CO_19',
      status: 'Ticket Generated but Data Not Received from CRM',
    },
    {
      statusCode: 'STS_CO_20',
      status: 'Ticket Cancelled Due to Change Request Device Change',
    },
    {
      statusCode: 'STS_CO_21',
      status: 'Ticket Cancelled Due to Change Request Vehicle Owner Change',
    },
    {
      statusCode: 'STS_CO_22',
      status: 'Ticket Cancelled Due to Change Request RTO or State Change',
    },
    {
      statusCode: 'STS_CO_23',
      status: 'Ticket Cancelled as per Request',
    },
    {
      statusCode: 'STS_CO_24',
      status: 'Ticket Cancelled Due to Invoice Cancelled',
    },
    {
      statusCode: 'STS_CO_25',
      status: 'Change required from CRM',
    },
    {
      statusCode: 'STS_CO_26',
      status: 'Other',
    },
    {
      statusCode: 'STS_CO_28',
      status: 'On Hold Due to Non-Working Hours',
    },
    {
      statusCode: 'STS_CO_29',
      status: 'On Hold Due to SIM Validity Issue',
    },
    {
      statusCode: 'STS_CO_30',
      status: 'Ticket Suspended Due to Customer Not Responding',
    },
    {
      statusCode: 'STS_CO_31',
      status: 'On Hold Due to No Response from Customer',
    },
    {
      statusCode: 'STS_CO_32',
      status: 'On Hold Due to Customer Details Mismatch',
    },
  ];

  remarks: string[] = [
    'Device Not Responding',
    'Device Replacement',
    'Device Mismatch',
    'Customer Not Cooperative',
    'Wrong RMN Received',
    'Panic Wire Cut',
    'Panic Button Not Pressed',
    'Vehicle Offline',
    'Local Vendor Tagged',
    'Old Vehicle',
    'Customer Did Not Answer the Call',
    'Refunded',
    'Vehicle in Workshop',
    'Vehicle in Body Shop',
    'Vehicle Not Available',
    'Driver Not Available',
    'Accident-Damaged Vehicle',
    'Incorrect Customer Details Received',
    'Dealer and Customer Not Responding',
    'Mobile Number Not Whitelisted',
    'SIM Validity Short',
    'SIM Card Not Active',
    'Customer Requested a Refund',
    'Incorrect Chassis Payment',
    'Backend Portal Issue',
    'VLTD not getting print',
    'Chassis and Engine Numbers Mismatched',
    'Vehicle Untagged',
    'Vehicle Outside RTO Boundary',
    'GPS False',
  ];

  kpiStatusMap = {
    ALL: null,

    PRO: [
      'STS_CO_01',
      'STS_CO_02',
      'STS_CO_03',
      'STS_CO_04',
      'STS_CO_05',
      'STS_CO_06',
    ],

    HOLD: [
      'STS_CO_07',
      'STS_CO_08',
      'STS_CO_09',
      'STS_CO_10',
      'STS_CO_11',
      'STS_CO_12',
      'STS_CO_13',
      'STS_CO_14',
      'STS_CO_15',
      'STS_CO_16',
      'STS_CO_17',
      'STS_CO_19',
      'STS_CO_25',
      'STS_CO_26',
      'STS_CO_28',
      'STS_CO_29',
      'STS_CO_30',
      'STS_CO_31',
      'STS_CO_32',
    ],

    COM: ['STS_CO_18'],

    CAN: ['STS_CO_20', 'STS_CO_21', 'STS_CO_22', 'STS_CO_23', 'STS_CO_24'],
  };

  filteredListOfTicketStatus: { status: string; statusCode: string }[] = [];
  ticketStatusFilterCtrl: FormControl = new FormControl();

  editFormFilteredListOfTicketStatus: { status: string; statusCode: string }[] =
    [];
  editFormTicketStatusFilterCtrl: FormControl = new FormControl();

  bulkEditFormFilteredListOfTicketStatus: {
    status: string;
    statusCode: string;
  }[] = [];
  bulkEditFormTicketStatusFilterCtrl: FormControl = new FormControl();

  private _onDestroy = new Subject<void>();
  maxDate: string = new Date().toISOString().split('T')[0];

  assignTo = '';
  state = '';
  dealerCode = '';
  initiatedBy = '';
  ticketStatusFilter = '';
  deviceType = '';
  tatType = '';
  status: string;
  ticketDashboardSearch = '';

  reportsDashboardForm: FormGroup = this.formBuilder.group({});
  ticketDashboardSearchForm: FormGroup = this.formBuilder.group({});
  ticketAssignedToForm: FormGroup = this.formBuilder.group({});
  updateTicketForm: FormGroup = this.formBuilder.group({});
  updateBulkTicketForm: FormGroup = this.formBuilder.group({});
  userPermission = [];
  loggedId = '';
  hierarchyLevel = -1;

  exportData = [];

  assignToTicketList: string[] = [];
  supportUsersList = [];
  searchStateWiseUser = '';
  searchStateWiseUserState = '';

  Dealer_Master_View = false;
  Institutional_Sales_View = false;
  Certification_Automation_View = false;
  Server_Monitoring_Dashboard_View = false;
  Vahan_Tagging_Automation_View = false;
  MyActivationsView = false;
  MyActivationsListView = false;
  MyActivationsEdit = false;

  MyActivationsViewMasterAccess = false;
  MyActivationsUpdateMasterAccess = false;

  isDownloading = false;

  files: File[] = [];

  // storage listener for cross-tab sync
  private storageListener = (event: StorageEvent) => {
    if (event.key === 'downloadInProgress') {
      this.isDownloading = event.newValue === 'true';
    }
  };

  constructor(
    public apiMicroservice: ApiServiceService,
    private formBuilder: FormBuilder,
    public router: Router,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    this.checkPermission();
    this.setTicketListForm();
    if (this.MyActivationsListView) {
      this.fetchData(this.kpiCardSelected);
      this.getAllCount();
      if (this.MyActivationsViewMasterAccess) {
        this.getAssignedUser();
      }
    }
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  checkPermission() {
    this.userPermission = JSON.parse(
      this.apiMicroservice.decryptData(
        sessionStorage.getItem('userPermission') || '[]'
      )
    );
    this.hierarchyLevel = Number(
      this.apiMicroservice.decryptData(
        sessionStorage.getItem('hierarchyLevel') || ''
      ) || -1
    );
    this.loggedId = this.apiMicroservice.decryptData(
      sessionStorage.getItem('userRefId') || ''
    );
    this.syncInitialDownloadState();
    this.userPermission.forEach(
      (element: {
        pageName: string;
        view: boolean;
        create: boolean;
        delete: boolean;
        update: boolean;
      }) => {
        if (
          element.pageName === 'My AIS 140 Tickets' &&
          element.view === false
        ) {
          this.navigateBack();
        }
        if (
          element.pageName === 'My AIS 140 Tickets' &&
          element.view === true
        ) {
          this.MyActivationsListView = true;
        }
        if (element.pageName === 'Dealer Master' && element.view === true) {
          this.Dealer_Master_View = true;
        }
        if (
          element.pageName === 'Institutional Sales' &&
          element.view === true
        ) {
          this.Institutional_Sales_View = true;
        }
        if (
          element.pageName === 'My Ticket Details page' &&
          element.view === true
        ) {
          this.MyActivationsView = true;
        }
        if (
          element.pageName === 'My Ticket Details page' &&
          element.update === true
        ) {
          this.MyActivationsEdit = true;
        }
        if (
          element.pageName === 'My AIS 140 Tickets Master Access' &&
          element.view === true
        ) {
          this.MyActivationsViewMasterAccess = true;
        }
        if (
          element.pageName === 'My AIS 140 Tickets Master Access' &&
          element.update === true
        ) {
          this.MyActivationsUpdateMasterAccess = true;
        }
        if (
          element.pageName === 'Certification Automation' &&
          element.view === true
        ) {
          this.Certification_Automation_View = true;
        }
        if (
          element.pageName === 'Server Monitoring Dashboard' &&
          element.view === true
        ) {
          this.Server_Monitoring_Dashboard_View = true;
        }
        if (
          element.pageName === 'Vahan Tagging Automation' &&
          element.view === true
        ) {
          this.Vahan_Tagging_Automation_View = true;
        }
      }
    );
  }

  syncInitialDownloadState() {
    // sync initial download state across tabs
    this.isDownloading = localStorage.getItem('downloadInProgress') === 'true';
    window.addEventListener('storage', this.storageListener);
  }

  setTicketListForm() {
    this.ticketDashboardSearchForm = this.formBuilder.group({
      ticketDashboardSearch: new FormControl(''),
    });

    this.reportsDashboardForm = this.formBuilder.group({
      fromDate: new FormControl(''),
      toDate: new FormControl(''),
      ticketCompletedAtFromDate: new FormControl(''),
      ticketCompletedAtToDate: new FormControl(''),
      state: new FormControl(''),
      dealerCode: new FormControl(''),
      assignTo: new FormControl(''),
      ticketStatusFilter: new FormControl(''),
      initiatedBy: new FormControl(''),
      deviceType: new FormControl(''),
      tatType: new FormControl(''),
    });

    this.ticketAssignedToForm = this.formBuilder.group({
      assignTo: ['', Validators.required],
    });
    this.updateTicketForm = this.formBuilder.group({
      remarkbyaccolade: ['', Validators.required],
      remark: [''],
      userRef: [this.loggedId, Validators.required],
      ticketNo: ['', Validators.required],
      vinNo: ['', Validators.required],
      imei: ['', Validators.required],

      fileNames: [''],
    });

    this.updateTicketForm
      .get('remarkbyaccolade')
      ?.valueChanges.subscribe((status) => {
        this.handleCertificateValidationSingle(status);
        // A remark written for the previous status rarely still applies to
        // the new one, so clear it here rather than let a stale remark get
        // carried into an unrelated status change. emitEvent: false avoids
        // re-triggering anything listening on 'remark' for this internal
        // reset. This also fires while updateTicketPopupClicked() patches
        // the form on open, but that patchValue call sets 'remark' to the
        // ticket's real value AFTER 'remarkbyaccolade' in the same object,
        // so the real value still wins on load.
        this.updateTicketForm.get('remark')?.setValue('', { emitEvent: false });
      });

    this.files = [];
    this.updateBulkTicketForm = this.formBuilder.group({
      remarkbyaccolade: ['', Validators.required],
      remark: [''],
      userRef: [this.loggedId, Validators.required],
      fileNames: [''],
    });

    this.updateBulkTicketForm
      .get('remarkbyaccolade')
      ?.valueChanges.subscribe((status) => {
        this.handleCertificateValidationBulk(status);
        this.updateBulkTicketForm.get('remark')?.setValue('', { emitEvent: false });
      });
  }

  getFormDetails() {
    this.fromDate = this.reportsDashboardForm.get('fromDate')?.value;
    this.toDate = this.reportsDashboardForm.get('toDate')?.value;
    this.ticketCompletedAtFromDate = this.reportsDashboardForm.get(
      'ticketCompletedAtFromDate'
    )?.value;
    this.ticketCompletedAtToDate = this.reportsDashboardForm.get(
      'ticketCompletedAtToDate'
    )?.value;
    this.state = this.reportsDashboardForm.get('state')?.value;
    this.dealerCode = this.reportsDashboardForm.get('dealerCode')?.value;
    this.assignTo = this.reportsDashboardForm.get('assignTo')?.value;
    this.initiatedBy = this.reportsDashboardForm.get('initiatedBy')?.value;
    this.ticketStatusFilter =
      this.reportsDashboardForm.get('ticketStatusFilter')?.value;
    this.deviceType = this.reportsDashboardForm.get('deviceType')?.value;
    this.tatType = this.reportsDashboardForm.get('tatType')?.value;
    this.ticketDashboardSearch = this.ticketDashboardSearchForm.get(
      'ticketDashboardSearch'
    )?.value;
    if (this.fromDate) {
      const originalDate = new Date(this.fromDate);
      originalDate.setHours(0, 0, 0, 0);
      this.fromDate = originalDate.toISOString();
    } else {
      this.fromDate = '';
    }
    if (this.toDate) {
      const originalDate = new Date(this.toDate);
      originalDate.setHours(23, 59, 59, 999);
      this.toDate = originalDate.toISOString();
    } else {
      this.toDate = '';
    }
    if (this.ticketCompletedAtFromDate) {
      const originalDate = new Date(this.ticketCompletedAtFromDate);
      originalDate.setHours(0, 0, 0, 0);
      this.ticketCompletedAtFromDate = originalDate.toISOString();
    } else {
      this.ticketCompletedAtFromDate = '';
    }
    if (this.ticketCompletedAtToDate) {
      const originalDate = new Date(this.ticketCompletedAtToDate);
      originalDate.setHours(23, 59, 59, 999);
      this.ticketCompletedAtToDate = originalDate.toISOString();
    } else {
      this.ticketCompletedAtToDate = '';
    }
    if (!this.MyActivationsViewMasterAccess) {
      this.assignedToId = this.loggedId;
    }
  }

  getAllCount() {
    this.getFormDetails();
    this.apiMicroservice
      .getAllVahanRegiCount(
        this.state,
        this.dealerCode,
        this.toDate,
        this.fromDate,
        this.assignTo,
        this.initiatedBy,
        this.ticketStatusFilter,
        this.deviceType,
        this.ticketDashboardSearch,
        this.assignedToId,
        this.ticketCompletedAtFromDate,
        this.ticketCompletedAtToDate,
        this.tatType
      )
      .subscribe((res) => {
        this.allCount = res.data.all;
        this.completed = res.data.completed;
        this.cancelled = res.data.cancelled;
        this.inProgress = res.data.inProgress;
        this.onHold = res.data.onHold;
      });
  }

  fetchData(kpiClicked) {
    this.kpiCardSelected = kpiClicked;
    if (this.kpiCardSelected === 'ALL') {
      this.table_title = 'All';
    } else if (this.kpiCardSelected === 'COM') {
      this.table_title = 'Completed';
    } else if (this.kpiCardSelected === 'PRO') {
      this.table_title = 'In Progress';
    } else if (this.kpiCardSelected === 'CAN') {
      this.table_title = 'Cancelled';
    } else if (this.kpiCardSelected === 'HOLD') {
      this.table_title = 'On Hold';
    }

    this.page = 1;
    this.size = 10;
    this.fetchList();
    this.getStatusList();
  }

  onPageChange(event: number) {
    this.page = event;
    this.fetchList();
  }

  onSizeChange(event: number) {
    this.page = 1;
    this.size = event;
    this.fetchList();
  }

  onSearch(event: string) {
    this.page = 1;
    this.ticketDashboardSearchForm.controls['ticketDashboardSearch'].setValue(
      event
    );
    this.ticketDashboardSearch = event;
    this.fetchList();
    this.getAllCount();
  }

  // Forwards the comma-separated bulk-uploaded search values as-is via the same
  // "search" query param the single search box already uses - the server treats a
  // single value as a partial match and multiple comma-separated values as an
  // exact-match $in across ticketNo/imei/vinNo/uid/iccid/ticketDescription.
  onBulkSearch(values: string) {
    const combinedSearch = values
      .split(',')
      .map((value) => value.trim())
      .filter((value) => !!value)
      .join(',');

    if (!combinedSearch) {
      this.apiMicroservice.openSnackbar(
        'No valid search values found in the uploaded sheet'
      );
      return;
    }

    this.onSearch(combinedSearch);
  }

  getFilterResult() {
    this.getFormDetails();
    this.page = 1;
    this.size = 10;
    this.fetchList();
    this.getAllCount();
    this.closeModal();
  }

  clear() {
    this.reportsDashboardForm.reset();
    this.reportsDashboardForm.controls['dealerCode'].setValue('');
    this.reportsDashboardForm.controls['state'].setValue('');
    this.reportsDashboardForm.controls['fromDate'].setValue('');
    this.reportsDashboardForm.controls['toDate'].setValue('');
    this.reportsDashboardForm.controls['ticketCompletedAtFromDate'].setValue(
      ''
    );
    this.reportsDashboardForm.controls['ticketCompletedAtToDate'].setValue('');
    this.reportsDashboardForm.controls['assignTo'].setValue('');
    this.reportsDashboardForm.controls['ticketStatusFilter'].setValue('');
    this.reportsDashboardForm.controls['initiatedBy'].setValue('');
    this.reportsDashboardForm.controls['deviceType'].setValue('');
    this.reportsDashboardForm.controls['tatType'].setValue('');
    this.ticketDashboardSearchForm.controls['ticketDashboardSearch'].setValue(
      ''
    );
    this.page = 1;
    this.size = 10;
    this.kpiCardSelected = 'ALL';
    this.fetchData(this.kpiCardSelected);
    this.getAllCount();
  }

  closeModal() {
    document
      ?.getElementById('filterDetails')
      ?.parentElement?.classList.remove('active');
  }

  closeOtherLinksModal() {
    document
      ?.getElementById('otherLinksPopUp')
      ?.parentElement?.classList.remove('active');
  }

  canEditTicket(item: any): boolean {
    const isCompletedOrCancelled = [
      ...this.kpiStatusMap.COM,
      ...this.kpiStatusMap.CAN,
    ].includes(item.remarkbyaccolade);

    if (isCompletedOrCancelled) {
      return !!this.MyActivationsUpdateMasterAccess;
    }

    return !!(
      this.MyActivationsUpdateMasterAccess || this.MyActivationsEdit
    );
  }

  private getSelectableTicketsOnCurrentPage() {
    return this.listOfData.filter((item) => this.canEditTicket(item));
  }

  isCurrentPageFullySelected(): boolean {
    const selectableTickets = this.getSelectableTicketsOnCurrentPage();

    return (
      selectableTickets.length > 0 &&
      selectableTickets.every((item) =>
        this.assignToTicketList.includes(item._id)
      )
    );
  }

  isCurrentPagePartiallySelected(): boolean {
    const selectableTickets = this.getSelectableTicketsOnCurrentPage();
    const selectedCount = selectableTickets.filter((item) =>
      this.assignToTicketList.includes(item._id)
    ).length;

    return selectedCount > 0 && selectedCount < selectableTickets.length;
  }

  toggleSelectAllTickets(event: Event) {
    const checked = (event.target as HTMLInputElement).checked;
    const selectableTickets = this.getSelectableTicketsOnCurrentPage();

    if (checked) {
      selectableTickets.forEach((item) => {
        if (!this.assignToTicketList.includes(item._id)) {
          this.assignToTicketList.push(item._id);
        }
      });
      return;
    }

    const currentPageIds = new Set(selectableTickets.map((item) => item._id));
    this.assignToTicketList = this.assignToTicketList.filter(
      (ticketId) => !currentPageIds.has(ticketId)
    );
  }

  removeTicketFromSelection(ticketId: string) {
    this.assignToTicketList = this.assignToTicketList.filter(
      (selectedTicketId) => selectedTicketId !== ticketId
    );
  }

  resetUpdateTicketFormState() {
    this.files = [];

    this.updateTicketForm.reset(
      {
        remarkbyaccolade: '',
        remark: '',
        userRef: this.loggedId,
        ticketNo: '',
        vinNo: '',
        imei: '',
        fileNames: '',
      },
      { emitEvent: false }
    );

    Object.values(this.updateTicketForm.controls).forEach((control) => {
      control.setErrors(null);
      control.markAsPristine();
      control.markAsUntouched();
      control.updateValueAndValidity({ onlySelf: true, emitEvent: false });
    });

    this.updateTicketForm.setErrors(null);
    this.updateTicketForm.markAsPristine();
    this.updateTicketForm.markAsUntouched();
    this.updateTicketForm.updateValueAndValidity({ emitEvent: false });

    const fileInput = document
      ?.getElementById('updateTicketPopup')
      ?.querySelector('input[type="file"]') as HTMLInputElement | null;

    if (fileInput) {
      fileInput.value = '';
    }
  }

  updateTicketPopupClicked(ticketDetails) {
    if (ticketDetails?._id) {
      this.removeTicketFromSelection(ticketDetails._id);
    }

    this.resetUpdateTicketFormState();
    this.getStatusList();

    document
      ?.getElementById('updateTicketPopup')
      ?.parentElement?.classList.add('active');

    this.updateTicketForm.patchValue({
      remarkbyaccolade: ticketDetails.remarkbyaccolade,
      userRef: this.loggedId,
      remark: ticketDetails.remark,
      ticketNo: ticketDetails.ticketNo,
      imei: ticketDetails.imei,
      vinNo: ticketDetails.vinNo,
    });

    this.handleCertificateValidationSingle(ticketDetails.remarkbyaccolade);
  }

  handleCertificateValidationSingle(status: string) {
    const fileCtrl = this.updateTicketForm.get('fileNames');

    if (status === 'STS_CO_18') {
      fileCtrl?.setValidators([Validators.required]);
    } else {
      fileCtrl?.clearValidators();
      fileCtrl?.setValue('');
      this.files = [];
    }
    fileCtrl?.updateValueAndValidity();
  }

  handleCertificateValidationBulk(status: string) {
    const bulkFileCtrl = this.updateBulkTicketForm.get('fileNames');

    if (status === 'STS_CO_18') {
      bulkFileCtrl?.setValidators([Validators.required]);
    } else {
      bulkFileCtrl?.clearValidators();
      bulkFileCtrl?.setValue('');
      this.files = [];
    }
    bulkFileCtrl?.updateValueAndValidity();
  }

  extractVinFromFileName(fileName: string): string | null {
    const match = fileName.match(/(MAT[A-Z0-9]{14})/i);

    return match ? match[1].toUpperCase() : null;
  }

  closeUpdateTicketPopupModal() {
    this.resetUpdateTicketFormState();

    document
      ?.getElementById('updateTicketPopup')
      ?.parentElement?.classList.remove('active');
  }

  submitUpdateTicketPopupModal() {
    if (this.updateTicketForm.invalid) {
      this.updateTicketForm.markAllAsTouched();
      return;
    }
    const payload = this.updateTicketForm.getRawValue();

    // Build body object as expected by server
    const bodyObj: any = {
      remark: payload.remark,
      remarkbyaccolade: payload.remarkbyaccolade,
      userRef: payload.userRef,
      ticketArray: [
        {
          ticketNo: payload.ticketNo,
          imei: payload.imei,
          vinNo: payload.vinNo,
        },
      ],
    };

    const formData = new FormData();
    formData.append('body', JSON.stringify(bodyObj));

    // Append files under the 'certificates' key to match the curl example
    this.files.forEach((file) => {
      formData.append('certificates', file);
    });

    this.spinner.show();
    this.apiMicroservice.editTickets(formData).subscribe({
      next: (res) => {
        this.spinner.hide();
        if (res.responseData && res.responseData[0]?.status === true) {
          this.apiMicroservice.openSnackbar(res.responseData[0].message);
          this.closeUpdateTicketPopupModal();
          this.ngOnInit();
        } else {
          this.apiMicroservice.openSnackbar(res.responseData[0].message);
        }
      },
      error: (error: HttpErrorResponse) => {
        this.spinner.hide();
        this.apiMicroservice.openSnackbar(
          `An error occurred while updating the ticket. ${error.message}`
        );
      },
    });
  }

  onFileChange(event: Event, mode: 'single' | 'bulk') {
    const input = event.target as HTMLInputElement;

    if (!input.files?.length) return;

    const selectedFiles = Array.from(input.files);

    if (mode === 'single') {
      const vinNo = this.updateTicketForm.get('vinNo')?.value || '';
      const invalidFiles: string[] = [];
      const validFiles: File[] = [];
      for (const file of selectedFiles) {
        const vin = this.extractVinFromFileName(file.name);
        if (!vin || vin.toUpperCase() !== vinNo.toUpperCase()) {
          invalidFiles.push(file.name);
        } else {
          validFiles.push(file);
        }
      }
      if (!validFiles.length) {
        this.apiMicroservice.openSnackbar(
          `Invalid certificate file(s): ${invalidFiles.join(', ')}. Filename must contain VIN ${vinNo}`
        );
        input.value = '';
        this.files = [];
        this.updateTicketForm.patchValue({ fileNames: '' });
        return;
      }

      // if (invalidFiles.length) {
      //   this.apiMicroservice.openSnackbar(
      //     `Invalid certificate file(s): ${invalidFiles.join(', ')}. Filename must contain VIN ${vinNo}`
      //   );
      //   input.value = '';
      //   this.files = [];
      //   this.updateTicketForm.patchValue({ fileNames: '' });
      //   return;
      // }

      this.files = validFiles;
      this.updateTicketForm.patchValue({
        fileNames: validFiles.map((f) => f.name).join(', '),
      });
      return;
    }

    // bulk
    const expectedVins = this.assignToTicketList
      .map((id) => this.listOfData.find((d) => d._id === id))
      .filter(Boolean)
      .map((d) => (d.vinNo || '').toUpperCase())
      .filter((v) => !!v) as string[];

    if (!expectedVins.length) {
      this.apiMicroservice.openSnackbar('No VINs found for selected tickets');
      input.value = '';
      return;
    }

    const vinToFile = new Map<string, File | null>();
    expectedVins.forEach((v) => vinToFile.set(v.toUpperCase(), null));

    const ignoredFiles: string[] = [];

    for (const file of selectedFiles) {
      const vin = this.extractVinFromFileName(file.name);
      if (!vin) {
        ignoredFiles.push(file.name);
        continue;
      }
      const matchVin = expectedVins.find(
        (v) => v.toUpperCase() === vin.toUpperCase()
      );
      if (matchVin) vinToFile.set(matchVin.toUpperCase(), file);
      else ignoredFiles.push(file.name);
    }

    const missingVins = Array.from(vinToFile.entries())
      .filter(([, f]) => f === null)
      .map(([v]) => v);

    if (missingVins.length) {
      this.apiMicroservice.openSnackbar(
        `Missing certificate for VIN(s): ${missingVins.join(', ')}`
      );
      input.value = '';
      this.files = [];
      this.updateBulkTicketForm.patchValue({ fileNames: '' });
      return;
    }
    const matchedFiles = Array.from(vinToFile.values()).filter(
      Boolean
    ) as File[];

    this.files = matchedFiles;
    this.updateBulkTicketForm.patchValue({
      fileNames: matchedFiles.map((f) => f.name).join(', '),
    });

    // if (ignoredFiles.length) {
    //   this.apiMicroservice.openSnackbar(
    //     `Ignored files not matching selected VINs: ${ignoredFiles.join(', ')}`
    //   );
    // }
  }

  clearBulkUpdate() {
    this.updateBulkTicketForm.reset(
      {
        remarkbyaccolade: '',
        remark: '',
        userRef: this.loggedId,
        fileNames: '',
      },
      { emitEvent: false }
    );

    // Ensure conditional validators and stale form errors are fully cleared.
    this.handleCertificateValidationBulk('');

    Object.values(this.updateBulkTicketForm.controls).forEach((control) => {
      control.setErrors(null);
      control.markAsPristine();
      control.markAsUntouched();
      control.updateValueAndValidity({ onlySelf: true, emitEvent: false });
    });

    this.updateBulkTicketForm.setErrors(null);
    this.updateBulkTicketForm.markAsPristine();
    this.updateBulkTicketForm.markAsUntouched();
    this.updateBulkTicketForm.updateValueAndValidity({ emitEvent: false });

    this.files = [];
  }

  submitBulkUpdate() {
    if (this.updateBulkTicketForm.invalid) {
      this.updateBulkTicketForm.markAllAsTouched();
      return;
    }

    if (!this.assignToTicketList.length) {
      this.apiMicroservice.openSnackbar('No tickets selected for bulk update');
      return;
    }

    const values = this.updateBulkTicketForm.getRawValue();

    const ticketArray = this.assignToTicketList
      .map((id) => this.listOfData.find((d) => d._id === id))
      .filter(Boolean)
      .map((d) => ({ ticketNo: d.ticketNo, imei: d.imei, vinNo: d.vinNo }));

    const bodyObj: any = {
      remark: values.remark,
      remarkbyaccolade: values.remarkbyaccolade,
      userRef: values.userRef,
      ticketArray,
    };

    const formData = new FormData();
    formData.append('body', JSON.stringify(bodyObj));
    this.files.forEach((file) => formData.append('certificates', file));

    this.spinner.show();
    this.apiMicroservice.editTickets(formData).subscribe({
      next: (res) => {
        this.spinner.hide();
        if (res.responseData && res.responseData[0]?.status === true) {
          this.apiMicroservice.openSnackbar(res.responseData[0].message);
          window.location.reload();
        } else {
          this.apiMicroservice.openSnackbar(
            res.responseData?.[0]?.message || 'Bulk update failed'
          );
        }
      },
      error: (error: HttpErrorResponse) => {
        this.spinner.hide();
        this.apiMicroservice.openSnackbar(
          `An error occurred while updating tickets. ${error.message}`
        );
      },
    });
  }

  fetchList() {
    this.spinner.show();
    this.listOfData = [];
    this.getFormDetails();
    this.apiMicroservice
      .getAllMyActivity(
        this.page,
        this.size,
        this.assignedToId,
        this.fromDate,
        this.toDate,
        this.state,
        this.assignTo,
        this.ticketStatusFilter,
        this.dealerCode,
        this.initiatedBy,
        this.kpiCardSelected,
        this.ticketDashboardSearch,
        this.deviceType,
        this.ticketCompletedAtFromDate,
        this.ticketCompletedAtToDate,
        this.tatType
      )
      .subscribe((res) => {
        this.spinner.hide();
        this.totalLength = 0;
        if (res.status === true) {
          this.listOfData = res.data.data;
          this.totalLength = res.data.totalItems;
          this.apiMicroservice.openSnackbar('Fetched Successfully');
        }
      });
  }

  filterDropdownMenus() {
    document
      ?.getElementById('filterDetails')
      ?.parentElement?.classList.add('active');
    this.getAllDealers();
    this.getAssignedUser();
    this.getStateList();
    this.getStatusList();
  }

  getAllDealers() {
    this.apiMicroservice.getAllDealers(1, 10000, '').subscribe((res) => {
      if (res.status) {
        this.spinner.hide();
        this.listOfDealers = res.data.data;
        this.filteredListOfDealers = this.listOfDealers.slice();
        this.dealerCodeFilterCtrl.valueChanges
          .pipe(takeUntil(this._onDestroy))
          .subscribe((search: string) => {
            if (!search) {
              this.filteredListOfDealers = [...this.listOfDealers];
              return;
            }

            // Filter the list based on search value
            search = search.toLowerCase();
            this.filteredListOfDealers = this.listOfDealers.filter(
              (item: { posCode: string }) =>
                item.posCode.toLowerCase().includes(search)
            );
          });
      }
    });
  }

  getAssignedUser() {
    this.supportUsersList = [];
    this.listOfAssignedUser = [];
    this.filteredListOfAssignedUser = [];
    this.apiMicroservice.userAssignmentList('', '').subscribe((res) => {
      this.supportUsersList = res.data;
      this.listOfAssignedUser = res.data;
      this.filteredListOfAssignedUser = res.data;
      this.userNameFilterCtrl.valueChanges
        .pipe(takeUntil(this._onDestroy))
        .subscribe((search: string) => {
          if (!search) {
            this.filteredListOfAssignedUser = [...this.listOfAssignedUser];
            return;
          }

          // Filter the list based on search value
          search = search.toLowerCase();
          this.filteredListOfAssignedUser = this.listOfAssignedUser.filter(
            (item) =>
              item.firstName.toLowerCase().includes(search) ||
              item.lastName.toLowerCase().includes(search)
          );
        });
    });
  }

  getStateList() {
    this.apiMicroservice.getAllGovtServerList().subscribe((res) => {
      if (res.status) {
        this.listOfState = res.data.map((element) => ({
          name: element.state,
          value: element.stateAbbreviation,
        }));
        this.filteredListOfState = this.listOfState.slice();
        this.stateNameFilterCtrl = new FormControl();
        this.stateNameFilterCtrl.valueChanges
          .pipe(takeUntil(this._onDestroy))
          .subscribe((search: string) => {
            if (!search) {
              this.filteredListOfState = [...this.listOfState];
              return;
            }

            // Filter the list based on search value
            search = search.toLowerCase();
            this.filteredListOfState = this.listOfState.filter((item) =>
              item.name.toLowerCase().includes(search)
            );
          });
      }
    });
  }

  getStatusList() {
    this.editFormFilteredListOfTicketStatus = this.listOfTicketStatus;
    this.editFormTicketStatusFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe((search: string) => {
        if (!search) {
          this.editFormFilteredListOfTicketStatus =
            this.listOfTicketStatus.slice();
          return;
        }

        search = search.toLowerCase();

        this.editFormFilteredListOfTicketStatus =
          this.listOfTicketStatus.filter(
            (item) =>
              item.status.toLowerCase().includes(search) ||
              item.statusCode.toLowerCase().includes(search)
          );
      });

    this.bulkEditFormFilteredListOfTicketStatus = this.listOfTicketStatus;
    this.bulkEditFormTicketStatusFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe((search: string) => {
        if (!search) {
          this.bulkEditFormFilteredListOfTicketStatus =
            this.listOfTicketStatus.slice();
          return;
        }

        search = search.toLowerCase();

        this.bulkEditFormFilteredListOfTicketStatus =
          this.listOfTicketStatus.filter(
            (item) =>
              item.status.toLowerCase().includes(search) ||
              item.statusCode.toLowerCase().includes(search)
          );
      });

    let kpiFilteredStatusList = this.listOfTicketStatus;

    const allowedCodes = this.kpiStatusMap[this.kpiCardSelected];

    if (allowedCodes) {
      kpiFilteredStatusList = this.listOfTicketStatus.filter((item) =>
        allowedCodes.includes(item.statusCode)
      );
    }

    this.filteredListOfTicketStatus = kpiFilteredStatusList.slice();

    this.ticketStatusFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe((search: string) => {
        if (!search) {
          this.filteredListOfTicketStatus = kpiFilteredStatusList.slice();
          return;
        }

        search = search.toLowerCase();

        this.filteredListOfTicketStatus = kpiFilteredStatusList.filter(
          (item) =>
            item.status.toLowerCase().includes(search) ||
            item.statusCode.toLowerCase().includes(search)
        );
      });
  }

  downloadTicketDetailsReport() {
    try {
      if (confirm(`Do you want to download report?`)) {
        // mark download in-progress and notify other tabs
        this.isDownloading = true;
        localStorage.setItem('downloadInProgress', 'true');
        this.apiMicroservice.openSnackbar(
          'Your file is being generated. Refreshing the page or logging out may interrupt the download.'
        );
        this.getFormDetails();
        this.apiMicroservice
          .downloadTicketDetailsReport(
            this.fromDate,
            this.toDate,
            this.state,
            this.assignTo,
            this.ticketStatusFilter,
            this.dealerCode,
            this.initiatedBy,
            this.kpiCardSelected,
            this.ticketDashboardSearch,
            this.deviceType,
            this.ticketCompletedAtFromDate,
            this.ticketCompletedAtToDate
          )
          .subscribe({
            next: (res) => {
              try {
                if (res?.status && res.fileDownloadUrl) {
                  const link = document.createElement('a');
                  link.href = res.fileDownloadUrl;
                  link.download = ''; // let browser infer filename
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);

                  this.apiMicroservice.openSnackbar('File ready for download');
                } else {
                  this.apiMicroservice.openSnackbar(
                    res?.message || 'File URL not available'
                  );
                }
              } finally {
                // clear in-progress state
                this.isDownloading = false;
                localStorage.setItem('downloadInProgress', 'false');
              }
            },
            error: (ERROR: HttpErrorResponse) => {
              const example =
                ERROR.error.message ||
                'Download failed. Please contact server team.';
              this.apiMicroservice.openSnackbar(example);
              // clear in-progress state
              this.isDownloading = false;
              localStorage.setItem('downloadInProgress', 'false');
            },
          });
      }
    } catch (error) {
      this.spinner.hide();
      console.error(error);
    }
  }

  resendTicketStatus() {
    try {
      if (confirm(`Do you want to resend Ticket Status report?`)) {
        this.getFormDetails();
        if (
          !this.fromDate &&
          !this.toDate &&
          !this.state &&
          !this.assignTo &&
          !this.ticketStatusFilter &&
          !this.dealerCode &&
          !this.initiatedBy &&
          !this.kpiCardSelected &&
          !this.ticketDashboardSearch &&
          !this.deviceType &&
          !this.ticketCompletedAtFromDate &&
          !this.ticketCompletedAtToDate
        ) {
          this.apiMicroservice.openSnackbar(
            'Please select filters before resending the report'
          );
          return;
        }
        this.spinner.show();
        this.apiMicroservice
          .resendTicketStatus(
            this.fromDate,
            this.toDate,
            this.state,
            this.assignTo,
            this.ticketStatusFilter,
            this.dealerCode,
            this.initiatedBy,
            this.kpiCardSelected,
            this.ticketDashboardSearch,
            this.deviceType,
            this.ticketCompletedAtFromDate,
            this.ticketCompletedAtToDate
          )
          .subscribe({
            next: (res) => {
              try {
                this.apiMicroservice.openSnackbar(
                  res?.message || 'Ticket Status report resent successfully'
                );
                this.spinner.hide();
                this.closeModal();
              } catch (error) {
                console.error(error);
                this.spinner.hide();
              }
            },
            error: (ERROR: HttpErrorResponse) => {
              const example =
                ERROR.error.message ||
                'Resend failed. Please contact server team.';
              this.apiMicroservice.openSnackbar(example);
            },
          });
      }
    } catch (error) {
      this.spinner.hide();
      console.error(error);
    }
  }

  viewTicket(id: string, uid: string) {
    sessionStorage.setItem('uidRef', uid);
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/ais140-ticket-details', id])
    );
    const fullUrl = window.location.origin + url;

    // Open the URL in a new tab
    window.open(fullUrl, '_blank');
  }

  saveAssignedTo() {
    const values = this.ticketAssignedToForm.value;
    if (this.ticketAssignedToForm.valid) {
      this.spinner.show();
      const payload = {
        ticketList: this.assignToTicketList,
        assignedTo: values.assignTo,
        userRef: this.loggedId,
      };
      this.apiMicroservice.assignMultiUser(payload).subscribe({
        next: (res) => {
          this.spinner.hide();
          if (res.status) {
            window.location.reload();
            this.apiMicroservice.openSnackbar(res.message);
          } else {
            window.location.reload();
            this.apiMicroservice.openSnackbar(res.message);
          }
        },
        error: (err) => {
          console.error(err);
          this.apiMicroservice.openSnackbar(err.message);
          this.spinner.hide();
        },
      });
    } else {
      this.ticketAssignedToForm.controls['assignTo'].markAsTouched();
    }
  }

  clearAssignedTo() {
    this.ticketAssignedToForm.reset(
      {
        assignTo: '',
      },
      { emitEvent: false }
    );

    Object.values(this.ticketAssignedToForm.controls).forEach((control) => {
      control.setErrors(null);
      control.markAsPristine();
      control.markAsUntouched();
      control.updateValueAndValidity({ onlySelf: true, emitEvent: false });
    });

    this.ticketAssignedToForm.setErrors(null);
    this.ticketAssignedToForm.markAsPristine();
    this.ticketAssignedToForm.markAsUntouched();
    this.ticketAssignedToForm.updateValueAndValidity({ emitEvent: false });
  }

  onViewChange(e, id) {
    const checked = (e.target as HTMLInputElement).checked;

    if (checked === true) {
      if (!this.assignToTicketList.includes(id)) {
        this.assignToTicketList.push(id);
      }
    } else {
      this.removeTicketFromSelection(id);
    }
  }

  openOtherLinksPopUp() {
    document
      ?.getElementById('otherLinksPopUp')
      ?.parentElement?.classList?.add('active');
  }

  filteredRemarks(value: string | null): string[] {
    if (!value) {
      return this.remarks;
    }

    const filterValue = value.toLowerCase();

    return this.remarks.filter((option) =>
      option.toLowerCase().includes(filterValue)
    );
  }

  openExternal(url: string) {
    window.open(url, '_blank');
  }

  redirect(to: string): void {
    this.router.navigate([to]);
  }

  navigateBack() {
    this.apiMicroservice.back();
  }
}
